import { EventsTimeSeriesDataPoint } from 'src/app/shared/utils/events-utils.service';

// ============================================================================
// Chart Colors
// ============================================================================

export const SCANNER_CHART_COLORS = {
  // Bar series (left Y-axis)
  volume: 'rgba(96, 107, 119, 0.7)',
  events: 'rgba(88, 149, 215, 0.7)',

  // Score line (right Y-axis)
  score: '#FFD700',

  // ESG sub-scores
  esgE: '#4CAF50',
  esgS: '#2196F3',
  esgG: '#9C27B0',

  // Sentiment
  sentimentLong: '#9D69FF',
  sentimentShort: '#FFD700',
} as const;

// ============================================================================
// Data Point Models
// ============================================================================

export interface ScoreDataPoint {
  score: number | null;
  date: string;
}

export interface VolumeDataPoint {
  volume: number;
  date: string;
}

export interface EventsDataPoint {
  date: string;
  count: number;
}

// ============================================================================
// Chart Data Models
// ============================================================================

/**
 * Complete chart data structure returned by ScannerChartDataService
 * and consumed by ScannerChartComponent
 */
export interface ScannerChartData {
  scoreData: ScoreDataPoint[];
  volumeData: VolumeDataPoint[];
  eventsData: EventsDataPoint[];
  dates: string[];
  scoreEData?: ScoreDataPoint[];
  scoreSData?: ScoreDataPoint[];
  scoreGData?: ScoreDataPoint[];
  scoreSentiLongData?: ScoreDataPoint[];
  scoreSentiShortData?: ScoreDataPoint[];
  sentimentLongLabel?: string;
  sentimentShortLabel?: string;
}

export interface MergeChartDataInput {
  score?: ScoreDataPoint[];
  volume: VolumeDataPoint[];
  events: EventsTimeSeriesDataPoint[];
  scoreE?: ScoreDataPoint[];
  scoreS?: ScoreDataPoint[];
  scoreG?: ScoreDataPoint[];
  scoreSentiLong?: ScoreDataPoint[];
  scoreSentiShort?: ScoreDataPoint[];
}
